'use client';

import { c as _c } from "react/compiler-runtime";
import { useImageProvider } from '@7f-ui';
import { Card, CardDetails, CardImageContainer, CardTitle } from '@7f-ui/components/card/card';
import type { BeachChairStatus } from '@data-access/graphql/schema.types';
import { baseUrl } from '@utils/utils-config';
import Image from 'next/image';
import { Flags } from './flags';
type Props = {
  slug: string;
  experienceCount: number;
  accommodationCount: number;
  beachChairStatus: BeachChairStatus;
  headline: string;
  unavailable?: boolean;
  subHeadline?: string | null;
  headerImage?: {
    url?: string | null;
    alt?: string | null;
  } | null;
  isFixedWidth?: boolean;
};
export function DestinationCard(t0) {
  const $ = _c(24);
  const {
    headerImage,
    slug,
    headline,
    unavailable,
    accommodationCount,
    beachChairStatus,
    experienceCount,
    isFixedWidth: t1
  } = t0;
  const isFixedWidth = t1 === undefined ? false : t1;
  const {
    logo
  } = useImageProvider();
  const t2 = `/reiseziele/${slug}/`;
  let t3;
  if ($[0] !== t2) {
    t3 = baseUrl(t2);
    $[0] = t2;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const href = t3;
  const t4 = headerImage?.url ?? logo.fallbackSrc;
  const t5 = headerImage?.alt ?? "";
  let t6;
  if ($[2] !== t4 || $[3] !== t5) {
    t6 = <Image src={t4} alt={t5} className="overflow-hidden rounded-2xl object-cover" sizes="(max-width: 768px) 100vw, 40vw" fill={true} />;
    $[2] = t4;
    $[3] = t5;
    $[4] = t6;
  } else {
    t6 = $[4];
  }
  let t7;
  if ($[5] !== unavailable) {
    t7 = unavailable && <div className="absolute top-4 left-4 rounded-md bg-white px-1.5 py-0.5 font-button">bald verfügbar</div>;
    $[5] = unavailable;
    $[6] = t7;
  } else {
    t7 = $[6];
  }
  let t8;
  if ($[7] !== t6 || $[8] !== t7) {
    t8 = <CardImageContainer aspectRatio="video">{t6}{t7}</CardImageContainer>;
    $[7] = t6;
    $[8] = t7;
    $[9] = t8;
  } else {
    t8 = $[9];
  }
  let t9;
  if ($[10] !== accommodationCount || $[11] !== beachChairStatus || $[12] !== experienceCount) {
    t9 = <Flags accommodationCount={accommodationCount} beachChairStatus={beachChairStatus} experienceCount={experienceCount} />;
    $[10] = accommodationCount;
    $[11] = beachChairStatus;
    $[12] = experienceCount;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  let t10;
  if ($[14] !== headline) {
    t10 = <CardTitle title={headline} />;
    $[14] = headline;
    $[15] = t10;
  } else {
    t10 = $[15];
  }
  let t11;
  if ($[16] !== t10 || $[17] !== t9) {
    t11 = <CardDetails>{t9}{t10}</CardDetails>;
    $[16] = t10;
    $[17] = t9;
    $[18] = t11;
  } else {
    t11 = $[18];
  }
  let t12;
  if ($[19] !== href || $[20] !== isFixedWidth || $[21] !== t11 || $[22] !== t8) {
    t12 = <Card href={href} isFixedWidth={isFixedWidth}>{t8}{t11}</Card>;
    $[19] = href;
    $[20] = isFixedWidth;
    $[21] = t11;
    $[22] = t8;
    $[23] = t12;
  } else {
    t12 = $[23];
  }
  return t12;
}